export default "__VITE_ASSET__Ctc5BQkK__"